import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box } from "@mui/material";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import ReviewsList from "../../features/manageReviews/reviewsList";
import { isValidInput } from "../../utils/validations";

const ManageReviews = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Reviews</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Reviews
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
        </div>
        <ReviewsList />
      </div>
    </MainContainer>
  );
};

export default ManageReviews;
